export const mainSectionItems  = [
    {
        title : "이것이 진짜 크롤링이다",
        level : "입문",
        topic : "데이터 수집, 처리, 데이터 분석" ,
        goal : "Python, 웹크롤링", 
        educator : "스파르타코딩" ,
        rate : 4,
        reviewTotal : 250 , 
        price : 0 ,
        count : 5400 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "처음 만난 리액트",
        level : "입문",
        topic : "웹 프론트" ,
        goal : "React", 
        educator : "소플" ,
        rate : 3,
        reviewTotal : 200 , 
        price : 0 ,
        count : 200 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "Flutter 앱 개발 완성",
        level : "초급",
        topic : "모바일 앱 개발" ,
        goal : "Flutter", 
        educator : "DevStory" ,
        rate : 2,
        reviewTotal : 100 , 
        price : 10000 ,
        count : 100 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "이것이 진짜 크롤링이다",
        level : "입문",
        topic : "데이터 수집, 처리, 데이터 분석" ,
        goal : "Python, 웹크롤링", 
        educator : "스파르타코딩" ,
        rate : 4,
        reviewTotal : 250 , 
        price : 0 ,
        count : 5400 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    }
]

export const mainRoadmapItems = [
    {
        roadCourse_img : "https://cdn.inflearn.com/public/roadmaps/29efab75-3480-4482-8ad8-4e984a4022f8/roadmap-38.png" ,
        roadCourse_title : "R로 정복하는 데이터 분석"
    } ,
    {
        roadCourse_img : "https://cdn.inflearn.com/public/roadmaps/fa1e0dbf-1786-4d81-bd22-d412b7937500/roadmap-77.png" ,
        roadCourse_title : "우아한 형제들 스프링 완전 정복"
    } ,
    {
        roadCourse_img : "https://cdn.inflearn.com/public/roadmaps/c86d5f8f-2e37-4ee4-b3a9-cf39026d5fc4/roadmap-130.png" ,
        roadCourse_title : "마이크로소프트 개발자가 알려주는 자바 완전 정복"
    } ,
    {
        roadCourse_img : "https://cdn.inflearn.com/public/roadmaps/c86d5f8f-2e37-4ee4-b3a9-cf39026d5fc4/roadmap-130.png" ,
        roadCourse_title : "게임 개발 과정"
    } ,
    {
        roadCourse_img : "https://cdn.inflearn.com/public/roadmaps/375/cover/14921546-8764-4962-bc0a-ac4383e9424f/roadmap-163.png" ,
        roadCourse_title : "리액트로 배우는 프론트엔드 과정"
    }
]

export const mainReadingItems = [
    {
        img : "https://cdn.inflearn.com/public/files/pages/180fc479-e7f7-4da1-be59-a4da13fdf3c1/curation-infcon2022-story-main.png"  ,
        title : "[큐레이션]  " ,
        subtitle : "🌱 🏃 🎫 인프런의 첫 번째 오프라인 콘퍼런스,INFCON 2022! 인프콘 발표자분들 중엔인프런 지식공유자가 많다는 사실, 아시나요? 오늘은"
    } ,
    {
        img : "https://cdn.inflearn.com/public/files/pages/180fc479-e7f7-4da1-be59-a4da13fdf3c1/curation-infcon2022-story-main.png"  ,
        title : "[큐레이션] INFCON 2022 기념 릴레이 할인 통합편!" ,
        subtitle : "🌱 🏃 🎫 인프런의 첫 번째 오프라인 콘퍼런스,INFCON 2022! 인프콘 발표자분들 중엔인프런 지식공유자가 많다는 사실, 아시나요? 오늘은"
    } ,
    {
        img : "https://cdn.inflearn.com/public/files/pages/180fc479-e7f7-4da1-be59-a4da13fdf3c1/curation-infcon2022-story-main.png"  ,
        title : "[큐레이션] INFCON 2022 기념 릴레이 할인 통합편!" ,
        subtitle : "🌱 🏃 🎫 인프런의 첫 번째 오프라인 콘퍼런스,INFCON 2022! 인프콘 발표자분들 중엔인프런 지식공유자가 많다는 사실, 아시나요? 오늘은"
    }
]

export const mainReviewItems =  [
    {
        name : "박우진" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    } ,
    {
        name : "박안녕" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    } ,
    {
        name : "홍길동" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    } ,
    {
        name : "김철수" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    } ,
    {
        name : "홍영희" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    } ,
    {
        name : "호호" ,
        hours : 5 ,
        title : "실무자가 알려주는  Git - 입문편" , 
        content : "Git에 대해서 잘 몰랐었는데, 많은 도움이 되었습니다."
    }
]

export const mainApplyItems= [
    {
        title : "지식공유자 되기" ,
        content : "9개월간 온라인 기술 강의로만 1억원! 나의 지식을 나눠 사람들에게 배움의 기회를 주고, 의미있는 대가를 가져가세요." ,
        apply : "지식공유자"
    } ,
    {
        title : "인프런 비즈니스 신청" ,
        content : "모든 팀원의 인프런의 강의들을 자유롭게 학습하는 환경을 제공해주세요. \n 업무 스킬에 집중된 콘텐츠를 통해 최신 트렌드의 업무역량을 습득할 수 있습니다." ,
        apply : "비즈니스"
    },
    {
        title : "인프런 X 대학생" ,
        content : "학교와 인프런이 함께 하여,\n 많은 학생 분들께 정해진 커리큘럼 이외에도 필요한 학습을 보완하고, 더욱 성장할 수 있도록 도와드립니다." ,
        apply : "대학생"
    }
]

export const searchDummyData = [
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "리액트 강의" ,
        educator : "김정환"
    } ,
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "리액트 실습 강의" ,
        educator : "김정환"
    } ,
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "Vue 강의" ,
        educator : "김정환"
    } ,
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "안드로이드 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "리액트 네이티브 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "스프링 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "Node.js 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "iOS 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "html css javascript 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "리액트 중급 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "React 강의" ,
        educator : "김정환"
    },
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "React Native 강의" ,
        educator : "김정환"
    } ,
    {
        link : "#" ,
        img : "https://cdn.inflearn.com/public/courses/326905/cover/739f7b4b-1a9f-478f-a6a8-1a13bf58cae3/326905-eng.png" ,
        title : "ReactNative 입문 강의" ,
        educator : "김정환"
    }
]

export const courseListData  = [
    {
        title : "이것이 진짜 크롤링이다",
        level : "입문",
        topic : "데이터 수집, 처리, 데이터 분석" ,
        goal : "Python, 웹크롤링", 
        educator : "스파르타코딩" ,
        rate : 4,
        reviewTotal : 250 , 
        price : 0 ,
        count : 5400 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "처음 만난 리액트",
        level : "입문",
        topic : "웹 프론트" ,
        goal : "React", 
        educator : "소플" ,
        rate : 3,
        reviewTotal : 200 , 
        price : 0 ,
        count : 200 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "Flutter 앱 개발 완성",
        level : "초급",
        topic : "모바일 앱 개발" ,
        goal : "Flutter", 
        educator : "DevStory" ,
        rate : 2,
        reviewTotal : 100 , 
        price : 10000 ,
        count : 100 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "이것이 진짜 크롤링이다",
        level : "입문",
        topic : "데이터 수집, 처리, 데이터 분석" ,
        goal : "Python, 웹크롤링", 
        educator : "스파르타코딩" ,
        rate : 4,
        reviewTotal : 250 , 
        price : 0 ,
        count : 5400 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    } ,
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    },
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    },
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    },
    {
        title : "스프링 입문",
        level : "초급",
        topic : "백엔드" ,
        goal : "스프링, 자바, MVC", 
        educator : "김영한" ,
        rate : 5,
        reviewTotal : 200 , 
        price : 100000 ,
        count : 6000 ,
        img : "https://cdn.inflearn.com/public/courses/327774/cover/18a5e94e-002b-413b-80b3-d9e14724ff08/%EA%B0%95%EC%9D%98%EC%86%8C%EA%B0%9C-002%20(5).png"
    }
]



export const courseDetailIntroduce = {
    previewCnt : 2 ,
    studentsCnt : 200 ,
    toLearn : ["네이버 뉴스 데이터 수집 방법" , "주식 데이터 수집 방법", "쇼핑몰 데이터 수집 방법" , "웹 크롤링 기초 (Requests, Beautifulsoup 사용법)"] ,
    courseContent : "고민하기 전에 먼저 들어보세요! 무료로 진행되는 강의이니 별로라면 더 안 들으면 그만입니다.하지만 아마 끝까지 듣게 되실 겁니다. 기초부터 심화 내용까지! 강의에서 모두 알려드릴 테니까요." ,
    recommendTo : ["내가 원하는 사이트를 크롤링 하려니 오류만 나는 분", "데이터 수집을 처음부터 제대로 배워보고 싶은 분" , "뉴스 데이터 수집을 자동으로 하고 싶은 분"] ,
    preKnowledge : ["파이썬 완전 기초 지식" , "스타트코딩 유튜브만 보고와도 가능"]  ,
    educatorProfile : ["스타트코딩 유튜브만 보고와도 가능" , "한국능률협회(KMA) 강사" , "KT, 대상그룹, 에스오일 등 기업교육 강사"] ,
    educatorImg : "http://www.wolyo.co.kr/news/photo/202006/106288_65303_3856.jpg" ,
    postingDate : "2021년 10월 18일" ,
    updateDate : "2022년 02월 19일" 
}

export const courseDetailCurriculum = [
    [{section : "섹션 0. 강의소개"} , ["강의소개" , "프로그래밍을 위한 마음가짐" , "크롤링 주의사항"]],
    [{section : "섹션 1. 환경설정"} , ["파이썬 설치" , "VS CODE 설치 및 사용방법" ]],
    [{section : "섹션 3. 준비운동"} , ["크롤링을 위한 정말 쉬운 HTML - 뉴스 해킹" , "HTML을 파이썬으로 가져오자 : requests" , "내가 원하는 태그를 선택하자 : beautifulsoup"]]
]